import React from 'react';

const SECTIONS = [
  { icon: '🎨', title: 'Brand Files', desc: 'Logos, brand guidelines, colour palettes, and approved brand assets.' },
  { icon: '📐', title: 'Templates', desc: 'Reusable design templates for social media, emailers, banners, and brochures.' },
  { icon: '📁', title: 'Documents', desc: 'Contracts, SOPs, onboarding docs, and reference materials.' },
];

export default function AssetsPage() {
  return (
    <div>
      <div className="section-head">
        <h2>Assets</h2>
      </div>
      <div style={{
        background:'var(--surface2)',border:'1px solid var(--border)',borderRadius:'var(--radius)',
        padding:'32px 24px',textAlign:'center',marginBottom:24,
      }}>
        <div style={{fontSize:32,marginBottom:10}}>📂</div>
        <div style={{fontWeight:700,fontSize:16,color:'var(--text1)',marginBottom:6}}>Asset Library — Coming Soon</div>
        <div style={{fontSize:13,color:'var(--text2)',maxWidth:480,margin:'0 auto'}}>
          A central place for 8D Studios brand files, templates, and client documents. Upload once, access everywhere.
        </div>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(220px,1fr))',gap:12}}>
        {SECTIONS.map(s => (
          <div key={s.title} className="card" style={{padding:'20px 18px',textAlign:'center',opacity:.7}}>
            <div style={{fontSize:28,marginBottom:10}}>{s.icon}</div>
            <div style={{fontWeight:700,fontSize:14,color:'var(--text1)',marginBottom:6}}>{s.title}</div>
            <div style={{fontSize:12,color:'var(--text2)',lineHeight:1.5}}>{s.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
